<div>
  <opath-core-nav-header
    #header
    [title]="translation.search.title"
    [buttons]="searchButtons"
    [justyButtons]="'space-between'"
    [height]="100"
    [disableFilterMode]="true"
    (onSearchTermChanged)="applyFilter($event)"
  >
  </opath-core-nav-header>
  <div>
    <p class="text" [style.color]="this.currentSearchText !== (null || '') && searchOccurence == 0 ? 'red' : ''">
      {{ searchResultDisplayed() }}
    </p>
  </div>
  <div class="replace-text-container">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <p class="text">{{ translation.replace.title }}</p>
      <abc-button
        class="collapse-btn"
        [icon]="collapsed ? 'chevrondown' : 'chevronup'"
        (click)="toggleReplaceContainer()"
      ></abc-button>
    </div>
    <div class="replace-text-container" [style.height.px]="collapsed ? '0' : '80'">
      <abc-text-box
        [height]="35"
        [placeholder]="translation.replace.placeholder"
        [showClearButton]="true"
        valueChangeEvent="keyup"
        (onValueChanged)="handleReplaceText($event.value)"
        class="searchInput"
      ></abc-text-box>
      <div class="flex-container">
        <abc-button
          class="button"
          *ngFor="let replaceModeButton of replaceModeButtons"
          [icon]="replaceModeButton.icon"
          [toolTipContent]="replaceModeButton.Tooltip"
          (click)="handleActivereplaceModeButton(replaceModeButton)"
          (onbuttonStateChanged)="refreshButtonsState()"
        ></abc-button>
      </div>
    </div>
  </div>
</div>
